/**
 * Extracts properties from `props` that are not present in `mapped`.
 * @param original The original object containing all properties.
 * @param excluded The object containing properties to exclude.
 * @returns An object containing properties from `props` that are not in `mapped`.
 */
function extractRest<T extends object, U extends object>(
  original: T,
  excluded: U,
): Omit<T, keyof U> {
  type NonTKey = keyof Omit<T, keyof U>;

  return Object.keys(original).reduce(
    (acc, key) => {
      if (!(key in excluded)) {
        acc[key as NonTKey] = original[key as NonTKey];
      }

      return acc;
    },
    {} as Omit<T, keyof U>,
  );
}

export default extractRest;
